export default {
  "Bebês": {
    valor: 'Bebês',
  },
  "Crianças": {
    valor: 'Crianças',
  },
  "Adolescentes": {
    valor: 'Adolescentes',
  },
  "Adultos": {
    valor: 'Adultos',
  },
  "Idosos": {
    valor: 'Idosos',
  },
};
